import { forwardRef } from "react";
import { initials, colorFor } from "./helpers";

const W = 900;

function Dot({ id, name, size = 30 }) {
  const c = colorFor(id);
  return (
    <span
      style={{
        width: `${size}px`, height: `${size}px`, borderRadius: "50%",
        background: `linear-gradient(135deg,${c},${c}cc)`, color: "#04120b",
        fontWeight: 800, fontSize: `${size * 0.4}px`,
        display: "inline-flex", alignItems: "center", justifyContent: "center",
        fontFamily: "'Barlow Condensed', sans-serif", flexShrink: 0,
      }}
    >
      {initials(name)}
    </span>
  );
}

export const PairsExportCard = forwardRef(({ pairs, playersMap = {} }, ref) => {
  const today = new Date().toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" });
  const medal = ["#F59E0B", "#9CA3AF", "#D97706"];

  return (
    <div
      ref={ref}
      style={{
        position: "fixed", left: "-10000px", top: 0, width: `${W}px`,
        background: "#0B0F19", padding: "40px", boxSizing: "border-box",
        fontFamily: "'Plus Jakarta Sans', sans-serif",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "16px", marginBottom: "26px" }}>
        <div
          style={{
            width: "56px", height: "56px", borderRadius: "16px",
            background: "linear-gradient(135deg,#10B981,#047857)",
            display: "flex", alignItems: "center", justifyContent: "center",
            color: "#04120b", fontWeight: 900, fontSize: "28px",
            fontFamily: "'Barlow Condensed', sans-serif",
          }}
        >
          AP
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 900, textTransform: "uppercase", fontSize: "34px", color: "#fff", lineHeight: 1 }}>
            American Padel 2026
          </div>
          <div style={{ color: "#10B981", fontSize: "14px", letterSpacing: "4px", marginTop: "4px" }}>
            CLASSIFICA COPPIE
          </div>
        </div>
        <div style={{ color: "#64748B", fontSize: "14px", textTransform: "capitalize" }}>{today}</div>
      </div>

      <div
        style={{
          display: "grid", gridTemplateColumns: "52px 1fr 90px 70px 80px",
          padding: "12px 16px", background: "#0b1120", borderRadius: "12px 12px 0 0",
          color: "#94a3b8", fontSize: "13px", textTransform: "uppercase", letterSpacing: "1px",
          fontFamily: "'JetBrains Mono', monospace",
        }}
      >
        <div style={{ textAlign: "center" }}>#</div>
        <div>Coppia</div>
        <div style={{ textAlign: "center" }}>V-P</div>
        <div style={{ textAlign: "center" }}>Diff</div>
        <div style={{ textAlign: "center" }}>Punti</div>
      </div>

      {pairs.map((p, i) => {
        const [idA, idB] = p.player_ids;
        const [nameA, nameB] = p.players;
        return (
          <div
            key={p.player_ids.join("-")}
            style={{
              display: "grid", gridTemplateColumns: "52px 1fr 90px 70px 80px",
              alignItems: "center", padding: "12px 16px",
              background: i % 2 ? "#0d1526" : "#111a2e",
              borderLeft: `4px solid ${i < 3 ? medal[i] : "transparent"}`,
            }}
          >
            <div style={{ textAlign: "center", fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 900, fontSize: "22px", color: i < 3 ? medal[i] : "#cbd5e1" }}>
              {p.rank}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div style={{ display: "flex" }}>
                <Dot id={idA} name={playersMap[idA]?.name || nameA} />
                <span style={{ marginLeft: "-8px" }}>
                  <Dot id={idB} name={playersMap[idB]?.name || nameB} />
                </span>
              </div>
              <span style={{ color: "#fff", fontWeight: 600, fontSize: "16px" }}>
                {nameA} / {nameB}
              </span>
            </div>
            <div style={{ textAlign: "center", fontFamily: "'JetBrains Mono', monospace", fontSize: "15px", color: "#cbd5e1" }}>
              {p.wins}-{p.losses}
            </div>
            <div style={{ textAlign: "center", fontFamily: "'JetBrains Mono', monospace", fontSize: "15px", fontWeight: 700, color: p.games_diff > 0 ? "#10B981" : p.games_diff < 0 ? "#f43f5e" : "#94a3b8" }}>
              {p.games_diff > 0 ? "+" : ""}{p.games_diff}
            </div>
            <div style={{ textAlign: "center" }}>
              <span style={{ display: "inline-block", minWidth: "40px", padding: "4px 8px", borderRadius: "8px", background: "rgba(16,185,129,0.15)", color: "#10B981", fontWeight: 900, fontFamily: "'JetBrains Mono', monospace", fontSize: "20px" }}>
                {p.points}
              </span>
            </div>
          </div>
        );
      })}

      <div style={{ marginTop: "20px", display: "flex", justifyContent: "space-between", color: "#64748B", fontSize: "13px", fontFamily: "'JetBrains Mono', monospace", letterSpacing: "1px" }}>
        <span>AMERICANA · STAGIONE 2026</span>
        <span>Ordine: Vittorie · Punti · Diff games</span>
      </div>
    </div>
  );
});

PairsExportCard.displayName = "PairsExportCard";
